import { SVGProps } from "react";

export const MastercardIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="8.39417" y="1.79053" width="6.55142" height="10.5854" fill="#F26122" />
      <path
        d="M9.10006 7.08347C9.08924 5.02321 10.0354 3.0721 11.6667 1.79078C8.87564 -0.380053 4.86631 -0.0648231 2.45707 2.51488C0.0478374 5.09458 0.0478374 9.07236 2.45707 11.6521C4.86631 14.2318 8.87564 14.547 11.6667 12.3762C10.0354 11.0948 9.08924 9.14373 9.10006 7.08347Z"
        fill="#EA1D25"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.1698 11.0889V11.5564H22.0873V11.0889H21.8948V10.9927H22.376V11.0889H22.1698ZM23.1048 10.9927V11.5564H23.0085V11.1302L22.8573 11.5014H22.7473L22.5823 11.1302V11.5564H22.486V10.9927H22.6235L22.8023 11.3914L22.9673 10.9927H23.1048Z"
        fill="#F69E1E"
      />
      <path
        d="M22.6776 7.08348C22.6759 9.65961 21.1882 12.009 18.8455 13.1351C16.5028 14.2611 13.7158 13.9665 11.6666 12.3762C14.6183 10.0776 15.1295 5.84871 12.8088 2.92675C12.4761 2.50363 12.0926 2.12217 11.6666 1.79079C13.7158 0.20044 16.5028 -0.0941805 18.8455 1.0319C21.1882 2.15798 22.6759 4.50736 22.6776 7.08348Z"
        fill="#F69E1E"
      />
    </svg>
  );
};
